import { useBoundStore } from 'useStore';
import PercentageChip from './PercentageChip';
import { useShallow } from 'zustand/react/shallow';

export default function ProjectedPercentageField({ type, id, field, value }) {
	const editedValue = useBoundStore(
		useShallow((state) => state.pricingEditedRows[id]?.[field])
	);

	const currentValue = editedValue ?? value;

	return <PercentageChip value={currentValue ?? 0} type={type} />;
}
